import ResourceFactory from 'app/common/lib/ResourceFactory';

const noop = () => {};

function unfollowBoard(options, callback) {
  const resource = ResourceFactory.create('BoardFollowResource', options);
  resource.callDelete().then(() => callback());
}

function followBoard(options, callback) {
  const resource = ResourceFactory.create('BoardFollowResource', options);
  resource.callCreate().then(() => callback());
}

function unfollowPinner(options, callback) {
  const resource = ResourceFactory.create('UserFollowResource', options);
  resource.callDelete().then(() => callback());
}

function followPinner(options, callback) {
  const resource = ResourceFactory.create('UserFollowResource', options);
  resource.callCreate().then(() => callback());
}

function unfollowTopic(options, callback) {
  const resource = ResourceFactory.create('InterestFollowResource', options);
  resource.callDelete().then(() => callback());
}

function followTopic(options, callback) {
  const resource = ResourceFactory.create('InterestFollowResource', options);
  resource.callCreate().then(() => callback());
}

function enablePFY(options, callback) {
  const resource = ResourceFactory.create('PFYPreferenceResource', options);
  resource.callCreate().then(() => callback());
}

function reportComplaint(options, callback) {
  const resource = ResourceFactory.create('PinFeedbackResource', options);
  resource.callUpdate().then(() => callback());
}

function reportPromotedComplaint(options, callback) {
  const resource = ResourceFactory.create('PinFeedbackResource', options);
  resource.callUpdate().then(() => callback());
}

function reportPin(options, callback) {
  callback();
}

function unrelatedSearchPin(options, callback) {
  const resource = ResourceFactory.create('SearchPinFeedbackResource', options);
  resource.callUpdate().then(() => callback());
}

function relatedPinHide(options, callback) {
  const resource = ResourceFactory.create('RelatedPinFeedbackResource', options);
  resource.callUpdate().then(() => callback());
}

function newsHubPinHide(options, callback) {
  const resource = ResourceFactory.create('NewsHubPinFeedbackResource', options);
  resource.callUpdate().then(() => callback());
}

export const actions = {
  complaint: reportComplaint,
  enablePFY,
  followBoard,
  followPinner,
  followTopic,
  newsHubPinHide,
  promotedComplaint: reportPromotedComplaint,
  relatedPinHide,
  reportPin,
  unfollowBoard,
  unfollowPinner,
  unfollowTopic,
  unrelatedSearchPin,
};

export const undoActionList = [
  'complaint',
  'relatedPinHide',
  'unrelatedSearchPin',
  'promotedComplaint',
  'newsHubPinHide',
  'unfollowBoard',
  'unfollowPinner',
  'unfollowTopic',
];
export function callPinFeedbackAction(action, options, callback = noop) {
  const actionFunc = actions[action];
  return actionFunc ? actionFunc(options, callback) : callback();
}
